export default (theme) => ({
    root: {
        position: 'relative',
        display: 'inline-block',
        cursor: 'pointer',
        userSelect: 'none',
        verticalAlign: 'middle',
    },
    input: {
        position: 'absolute',
        opacity: 0,
        width: 0,
        height: 0,
        margin: 0,
        padding: 0,
    },
    track: {
        display: 'flex',
        alignItems: 'center',
        boxSizing: 'border-box',
        borderRadius: 999,
        backgroundColor: theme.colors.actionMinor[500],
        transition: 'background-color 150ms ease',
    },
    trackEnriched: {
        background: `linear-gradient(to right, ${theme.colors.utility.promoGradientGreen}, ${theme.colors.utility.promoGradientBlue}, ${theme.colors.utility.promoGradientPurple})`,
    },
    trackChecked: {
        backgroundColor: theme.colors.actionMajor[500],
    },
    trackHovered: {
        backgroundColor: theme.colors.actionMinor[600],
    },
    trackCheckedHovered: {
        backgroundColor: theme.colors.actionMajor[600],
    },
    trackDisabled: {
        cursor: 'not-allowed',
    },
    trackDisabledOff: {
        backgroundColor: theme.colors.grey[200],
    },
    trackDisabledOn: {
        backgroundColor: theme.colors.actionMajor[150],
    },
    handle: {
        borderRadius: '50%',
        backgroundColor: theme.colors.primary.white,
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
        transition: 'transform 150ms ease',
    },
    // Size variants - small
    small: {
        '& $track': {
            width: 28,
            height: 16,
            padding: 2,
        },
        '& $handle': {
            width: 12,
            height: 12,
        },
        '& $handleChecked': {
            transform: 'translateX(12px)',
        },
    },
    medium: {
        '& $track': {
            width: 36,
            height: 20,
            padding: 2,
        },
        '& $handle': {
            width: 16,
            height: 16,
        },
        '& $handleChecked': {
            transform: 'translateX(16px)',
        },
    },
    large: {
        '& $track': {
            width: 44,
            height: 24,
            padding: 2,
        },
        '& $handle': {
            width: 20,
            height: 20,
        },
        '& $handleChecked': {
            transform: 'translateX(20px)',
        },
    },
    handleChecked: {},
    disabled: {
        cursor: 'not-allowed',
        pointerEvents: 'none',
    },
});
